// extracted by mini-css-extract-plugin
module.exports = {"content":"_2BXNzI"};